import { render, staticRenderFns } from "./BCXMarkBeforeWrapped.vue?vue&type=template&id=67252f86"
import script from "./BCXMarkBeforeWrapped.vue?vue&type=script&lang=ts"
export * from "./BCXMarkBeforeWrapped.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports